import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { BrowserRouter } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://20f20bc76eee03e92aef64d03785f182@o4509037468319744.ingest.de.sentry.io/4509037474676816",
  tracesSampleRate: 1.0,
  environment:
    import.meta.env.MODE === "development" ? "development" : "production",
  replaysSessionSampleRate: 0.1,
  integrations: [Sentry.replayIntegration()],
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Disable refetch on focus globally
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
